<template lang="pug">
#monitoramento-operacao
    BaseHeader(titulo='Visualizar monitoramento', :voltarPara='true')

    .view-container-base-header
        section.monitoramento-operacao__dados-gerais(v-if='dadosMonitoramento')
            .titulo_padrao
                | Dados gerais da operação monitorada

            .monitoramento-operacao__dados-gerais__body
                .row.mb-5
                    .col-4
                        .monitoramento-operacao__dados-gerais__body__title
                            | Nome
                        .monitoramento-operacao__dados-gerais__body__value
                            | {{ dadosMonitoramento.nome ? dadosMonitoramento.nome : '--' }}
                    .col-4
                        .monitoramento-operacao__dados-gerais__body__title
                            | Categoria
                        .monitoramento-operacao__dados-gerais__body__value
                            | {{ dadosMonitoramento.nomeCategoria }}
                    .col-4
                        .monitoramento-operacao__dados-gerais__body__title
                            | Identificador da operação
                        .monitoramento-operacao__dados-gerais__body__value
                            | {{ dadosMonitoramento.identificadorOperacao }}
                .row
                    .col-3
                        .monitoramento-operacao__dados-gerais__body__title
                            | Número do Contato
                        .monitoramento-operacao__dados-gerais__body__value
                            | {{ dadosMonitoramento.numeroContrato ? dadosMonitoramento.numeroContrato : '--' }}
                    .col-3
                        .monitoramento-operacao__dados-gerais__body__title
                            | Vigência
                        .monitoramento-operacao__dados-gerais__body__value
                            | {{ dadosMonitoramento.dataVigencia }}
                    .col-3
                        .monitoramento-operacao__dados-gerais__body__title
                            | Data da liberação
                        .monitoramento-operacao__dados-gerais__body__value
                            | {{ dadosMonitoramento.dataLiberacao }}
                    .col-3
                        .monitoramento-operacao__dados-gerais__body__title
                            | Data da contratação
                        .monitoramento-operacao__dados-gerais__body__value
                            | {{ dadosMonitoramento.dataContratacao }}

        section.monitoramento-operacao__restricoes
            .monitoramento-operacao__restricoes__icone
                i.mdi.mdi-bell.monitoramento-operacao__restricoes__icone__icone

            .monitoramento-operacao__restricoes__texto
                | {{ totalRestricoes }}

        section.monitoramento-operacao__listagem-territorios
            .titulo_padrao
                | Listagem de territórios monitorados

            .row.m-0
                .col-7.px-0.tabela
                    el-table(
                        :data='territorios',
                        stripe,
                        height='calc(100% - 54px)'
                    )
                        el-table-column(type='expand')
                            template(slot-scope='props')
                                .box-expande-listagem
                                    .box-expande-listagem-box
                                        .box-expande-listagem-box-texto
                                            | Área (ha)
                                        .box-expande-listagem-box-value
                                            div {{ props.row.areaHa }}

                                    .box-expande-listagem-box
                                        .box-expande-listagem-box-texto
                                            | Pessoa (CPF)
                                        .box-expande-listagem-box-value.lista-scroll(
                                            v-if='props.row.representantes !== null && props.row.representantes.length > 0'
                                        )
                                            div(
                                                v-for='(cpfCnpj, index) in props.row.representantes',
                                                :key='index'
                                            )
                                                div {{ cpfCnpj }}
                                        .pl-1(v-else) --

                                    .box-expande-listagem-box
                                        .box-expande-listagem-box-texto
                                            | CAR vinculado
                                        .box-expande-listagem-box-value.lista-scroll(
                                            v-if='props.row.cars !== null && props.row.cars.length > 0'
                                        )
                                            div(
                                                v-for='(car, index) in props.row.cars',
                                                :key='index'
                                            )
                                                div {{ car }}
                                        .pl-1(v-else) --

                        el-table-column(label='Território')
                            template(slot-scope='scope')
                                span {{ scope.row.nome }}

                        el-table-column(label='Localidade')
                            template(slot-scope='scope')
                                span {{ scope.row.municipio }}

                        el-table-column(label='Restrições')
                            template(slot-scope='scope')
                                span {{ scope.row.restricao }}

                        el-table-column(label='Operações')
                            template(slot-scope='scope')
                                span {{ scope.row.operacoes }}
                                el-tooltip(effect='dark', placement='top')
                                    template(slot='content')
                                        div(
                                            v-for='(operacao, index) in scope.row.operacoesRelacionadas',
                                            :key='index'
                                        )
                                            span {{ 'ID: ' + operacao.identificador + ' | Nome: ' + operacao.nome }}

                                    i.mdi.mdi-information-outline.ml-1

                        el-table-column(
                            label='Ações',
                            width='100',
                            align='center'
                        )
                            template(slot-scope='scope')
                                el-dropdown.action-button(trigger='click')
                                    span.el-dropdown-link
                                        i.mdi.mdi-dots-vertical
                                    el-dropdown-menu(slot='dropdown')
                                        el-dropdown-item(
                                            v-for='(acao, index) in acoesTerritorio',
                                            :key='index',
                                            :icon='acao.icone',
                                            @click.native='acao.callback(scope.row)'
                                        ) {{ acao.nome }}

                    .tabela-rodape
                        .tabela-rodape--esquerda
                            p {{ territorios.length }} territórios em monitoramento

                .col-5.pr-0
                    .mapaMonitoramentoOperacao
                        mapa(
                            :showStatesLayers='false',
                            :mapLayersConfigs='layersMaps',
                            :mapConfig='mapConfig',
                            :height='"100%"',
                            :idMapa='"mapaMonitoramentoOperacao"',
                            ref='mapa',
                            :doubleMapOnPage='false'
                        )

        section.monitoramento-operacao__listagem-pessoas
            .titulo_padrao
                | Listagem de pessoas monitoradas

            .row.m-0
                .col-12.px-0.tabela
                    el-table(
                        :data='pessoas',
                        stripe,
                        height='calc(100% - 54px)'
                    )
                        el-table-column(label='Nome ou razão social')
                            template(slot-scope='scope')
                                span {{ scope.row.nomeRazaoSocial }}

                        el-table-column(label='CPF/CNPJ')
                            template(slot-scope='scope')
                                span {{ scope.row.cpfCnpj }}

                        el-table-column(label='Papel da pessoa')
                            template(slot-scope='scope')
                                span {{ scope.row.papel }}

                        el-table-column(label='Restrições')
                            template(slot-scope='scope')
                                span {{ scope.row.restricoes }}

                        el-table-column(label='Operações')
                            template(slot-scope='scope')
                                span {{ scope.row.operacoes }}
                                el-tooltip(effect='dark', placement='top')
                                    template(slot='content')
                                        div(
                                            v-for='(operacao, index) in scope.row.operacoesRelacionadas',
                                            :key='index'
                                        )
                                            span {{ 'ID: ' + operacao.identificador + ' | Nome: ' + operacao.nome }}

                                    i.mdi.mdi-information-outline.ml-1

                        el-table-column(
                            label='Ações',
                            width='100',
                            align='center'
                        )
                            template(slot-scope='scope')
                                el-dropdown.action-button(trigger='click')
                                    span.el-dropdown-link
                                        i.mdi.mdi-dots-vertical
                                    el-dropdown-menu(slot='dropdown')
                                        el-dropdown-item(
                                            v-for='(acao, index) in acoesPessoas',
                                            :key='index',
                                            :icon='acao.icone',
                                            @click.native='acao.callback(scope.row)'
                                        ) {{ acao.nome }}

                    .tabela-rodape
                        .tabela-rodape--esquerda
                            p {{ pessoas.length }} pessoas em monitoramento

    ModalResultadoDiagnostico(
        ref='modalResultadoDiagnosticoRef',
        habilitar-inibicao-camada,
        @atualizarDadosMonitoramento='buscarDadosMonitoramentoOperacao'
    )
</template>

<script>
import ModalResultadoDiagnostico from '@/components/operacao/gestao/ModalResultadoDiagnostico.vue';
import OperacaoMonitoramentoService from '@/services/OperacaoMonitoramentoService';
import Mapa from '@/components/MapaLeaflet';
import BaseHeader from '@/components/BaseHeader.vue';

export default {
    name: 'index',
    components: { BaseHeader, ModalResultadoDiagnostico, Mapa },
    data() {
        return {
            acoesTerritorio: [
                {
                    nome: 'Visualizar análise do território',
                    icone: 'flow flow-environment',
                    callback: this.visualizarAnaliseTerritorio
                }
            ],
            acoesPessoas: [
                {
                    nome: 'Visualizar análise da pessoa',
                    icone: 'flow flow-environment',
                    callback: this.visualizarAnalisePessoa
                }
            ],
            dadosMonitoramento: null,
            diagnosticosProtocolo: [],
            territorios: [],
            totalRestricoes: 'Sem dados',
            pessoas: [],
            layersMaps: [],
            mapConfig: {
                controls: {
                    popupControl: false,
                    drawControl: false,
                    zoomControl: true,
                    camadasControl: false,
                    fullscreen: false,
                    buscarCarControl: false,
                    bufferControl: false,
                    uploadFileControl: false,
                    camadasBaseControl: false,
                    botaoAnotacoes: false,
                    ferramentasControl: false
                },
                inspecionar: false,
                diagnostico: false
            }
        };
    },

    async mounted() {
        await this.buscarDadosMonitoramentoOperacao();
    },

    methods: {
        adicionarPontosMapaTerritorio() {
            this.territorios.forEach(territorio => {
                this.layersMaps.push({
                    name: 'areaMonitorada_' + territorio.id,
                    geoJson: territorio.centroide,
                    style: {
                        radius: 4,
                        fill: true,
                        fillColor: '#27d14c',
                        color: '#27d14c',
                        weight: 10,
                        opacity: 0.3,
                        fillOpacity: 1.0
                    }
                });
            });
        },

        async buscarDadosMonitoramentoOperacao() {
            await OperacaoMonitoramentoService.buscarDadosMonitoramento(
                this.$route.params.id
            )
                .then(({ data }) => {
                    this.dadosMonitoramento = data;
                    this.territorios = data.territorios;
                    this.pessoas = data.pessoas;
                    this.totalRestricoes = data.totalRestricoes;

                    this.adicionarPontosMapaTerritorio();
                })
                .catch(() => {
                    this.$notify.error({
                        message:
                            'Não foi buscar os dados de monitoramento da operação.'
                    });
                    this.$router.push({ name: 'operacao' });
                });
        },

        async visualizarAnaliseTerritorio(territorio) {
            await OperacaoMonitoramentoService.buscarDadosAnaliseTerritorio(
                this.$route.params.id,
                territorio.id
            ).then(({ data }) => {
                const diagnostico = {
                    grupo: [
                        {
                            nome: territorio.nome,
                            territorioProximidade: false,
                            titulo: 'Área Analisada',
                            diagnostico: data.territorioResultado
                        }
                    ],
                    territorioGeometria: territorio.geometria
                };

                data.carResultado.forEach(car => {
                    diagnostico.grupo.push({
                        nome: car.car,
                        territorioProximidade: false,
                        titulo: 'CAR Analisado',
                        diagnostico: car.diagnostico
                    });
                });

                data.pessoaResultado.forEach(pessoa => {
                    diagnostico.grupo.push({
                        nome: pessoa.nome + ' | ' + pessoa.documento,
                        territorioProximidade: false,
                        titulo: 'Pessoa Analisada',
                        diagnostico: pessoa.diagnostico
                    });
                });

                this.$refs.modalResultadoDiagnosticoRef.abrirModal(diagnostico);
            });
        },

        async visualizarAnalisePessoa(pessoa) {
            await OperacaoMonitoramentoService.buscarDadosAnalisePessoa(
                this.$route.params.id,
                pessoa.id
            ).then(({ data }) => {
                this.$refs.modalResultadoDiagnosticoRef.abrirModal({
                    grupo: [
                        {
                            documento: data.pessoa.documento,
                            territorioProximidade: false,
                            nome: data.pessoa.nomeRepresentante,
                            titulo: 'Pessoa Analisada',
                            diagnostico: data.pessoa.diagnostico
                        }
                    ]
                });
            });
        }
    }
};
</script>

<style lang="scss">
#monitoramento-operacao {
    .monitoramento-operacao__header {
        margin: 0;
        align-items: center;
        padding: 20px;
        height: 100px;
        width: 100%;
        background-color: var(--white);
        box-shadow: 0 1px 5px 0 var(--block-shadow);

        .monitoramento-operacao__header__title {
            padding: 0;
            color: var(--primary-font-color);
            font-weight: map_get($font-weight, medium);
            font-size: map-get($font-size, x-large);
        }
    }

    .monitoramento-operacao__dados-gerais {
        margin-bottom: 20px;

        .monitoramento-operacao__dados-gerais__body {
            background-color: var(--white);
            height: 183px;
            width: 100%;
            padding: 24px;
            border-radius: $default-border-radius;
            box-shadow: 0 1px 5px 0 var(--block-shadow);

            .monitoramento-operacao__dados-gerais__body__title {
                font-size: 14px;
                color: var(--primary);
                margin-bottom: 5px;
            }

            .monitoramento-operacao__dados-gerais__body__value {
                font-size: 14px;
                color: var(--secondary-font-color);
            }
        }
    }

    .monitoramento-operacao__restricoes {
        background-color: #f883421a;
        border-radius: $default-border-radius;
        height: 55px;
        display: flex;
        align-items: center;
        position: relative;
        margin-bottom: 20px;
        box-shadow: 0 1px 5px 0 var(--block-shadow);

        .monitoramento-operacao__restricoes__icone {
            height: 100%;
            width: 60px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 4px 0 0 4px;
            background-color: var(--warning);
            margin-right: 20px;

            .monitoramento-operacao__restricoes__icone__icone {
                font-size: 24px;
                color: var(--white);
            }
        }

        .monitoramento-operacao__restricoes__texto {
            line-height: 16px;
            font-weight: 600;
            font-size: 14px;
        }
    }

    .monitoramento-operacao__listagem-territorios {
        margin-bottom: 20px;
    }

    .monitoramento-operacao__listagem-pessoas {
        margin-bottom: 20px;
    }

    .titulo_padrao {
        font-weight: 600;
        font-size: 18px;
        width: 100%;
        margin-bottom: 20px;
    }

    .voltar {
        cursor: pointer;
        margin-right: 10px;
    }

    .tabela {
        border-radius: 5px;
        height: 400px;
        padding: 0;
        background-color: var(--white);
        box-shadow: 0 1px 5px 0 var(--block-shadow);

        .el-table {
            border-radius: 5px;
            height: calc(100% - 54px);
            width: 100%;
        }

        .el-table th {
            color: var(--primary);
            font-weight: normal;
            font-size: 13px;
        }

        .el-table__row.expanded:hover,
        .el-table--enable-row-hover
            .el-table__body
            tr:hover
            > td.el-table__cell,
        .el-table__row.expanded,
        td.el-table__cell.el-table__expanded-cell {
            background-color: var(--background-rgba) !important;
        }

        .expanded
            td.el-table_1_column_1.undefined.el-table__expand-column.el-table__cell,
        .el-table__row.expanded,
        td.el-table__cell.el-table__expanded-cell {
            border-left: 2px solid var(--secondary) !important;
        }

        .tabela-btn {
            margin-top: 14px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
        }

        .tabela-rodape {
            height: 54px;
            background: var(--white);
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 14px 44% 10px 5px;
            border-radius: 5px;

            .tabela-rodape--esquerda p {
                margin-bottom: 0;
                color: var(--primary);
                margin-left: 10px;
            }

            .tabela-rodape--pagination {
                .el-pager li.active {
                    color: var(--white);
                    font-weight: 900;
                    background: var(--primary);
                }

                .el-pager li {
                    padding: 0 4px;
                    background: var(--white);
                    vertical-align: top;
                    display: inline-block;
                    font-size: 13px !important;
                    min-width: 28px !important;
                    height: 28px !important;
                    line-height: 28px !important;
                    box-sizing: border-box;
                    text-align: center;
                    margin: 0;
                    border-radius: 2px;
                    color: var(--primary);
                }

                .el-pagination button {
                    height: 28px;
                }
            }
        }

        .box-expande-listagem {
            display: flex;
            align-items: flex-start;
            justify-content: space-around;
            margin-top: 15px;
            margin-bottom: 15px;
            padding: 0 18px;

            .box-expande-listagem-box {
                width: 33%;

                .box-expande-listagem-box-texto {
                    font-weight: 600;
                    color: var(--primary);
                }

                .box-expande-listagem-box-value {
                    padding: 0;
                    max-height: 75px;
                    overflow-y: auto;
                    font-weight: 400;
                    color: var(--primary);
                }
            }
        }
    }

    .mapaMonitoramentoOperacao {
        background-color: #7777;
        height: 100%;
        width: 100%;
        border-radius: 5px;
    }

    #mapaMonitoramentoOperacao {
        border-radius: 5px;
    }

    .lista-scroll {
        max-height: 30px;
        overflow: auto;
    }
}
</style>
